// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"363":"e11c074f","433":"1fc12ae0","672":"a2dd523a","897":"28db1b6f","934":"c797fb09","961":"2c7c2750","986":"41ed2411"}[chunkId] + ".css";
};